import solidity from "refractor/solidity";
export default solidity;